import pageViewModel from './PageView'
import loginSuccess from './LoginSuccess'
import loginFail from './LoginFail'
import compliance from './Compliance'
import collapse from './Collapse'
import ecommerce from './Ecommerce'

const EVENTS = {
  PAGE_VIEW: 'PAGE_VIEW',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAIL: 'LOGIN_FAIL',
  ACTIVATE_COLLAPSE: 'ACTIVATE_COLLAPSE',
  ...compliance.EVENTS,
  ...ecommerce.EVENTS
}

const EventModels = {
  PAGE_VIEW: pageViewModel,
  LOGIN_SUCCESS: loginSuccess,
  LOGIN_FAIL: loginFail,
  ACTIVATE_COLLAPSE: collapse,
  ...compliance.EventModels,
  ...ecommerce.EventModels
}

export {
  EVENTS,
  EventModels
}



// WEBPACK FOOTER //
// ./src/analytics/Events/index.js